
{
  "fr": {
    "close": "fermer"
  }
}
